import React, { useState } from 'react';

function Dropdown(props) {
    const dropdownItems = [
        {
            id: "direct_el",
            title: props.DataModel.lang.direct_el_option
        },
        {
            id: "waterborne_el",
            title: props.DataModel.lang.waterborne_el_option
        },
        {
            id: "oil",
            title: props.DataModel.lang.oil_option,
        },
        {
            id: "pellets",
            title: props.DataModel.lang.pellets_option,
        },
        {
            id: "central",
            title: props.DataModel.lang.central_option,
        },
        {
            id: "heat_pump",
            title: props.DataModel.lang.heat_pump_option,
        }
    ];

    const [isDropdownOpened, setIsDropdownOpened] = useState(false);
    const [selectedItem, setSelectedItem] = useState(dropdownItems[0]);

    return (
        <div className='dropdown-wrapper'>
            <div className="selected-dropdown-item" onClick={() => setIsDropdownOpened(!isDropdownOpened)}>
                {selectedItem.title}
                <span className={`dropdown-arrow dropdown-arrow-${isDropdownOpened ? 'opened': 'closed'}`}>
                    <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.5 9L0.272757 3.57584e-07L16.7272 1.79608e-06L8.5 9Z" fill="#747678"/>
                    </svg>
                </span>
            </div>
            {isDropdownOpened &&
                <div className='dropdown-items'>
                    {dropdownItems.map( (dropdownItem) => {
                        return (
                            <div className='dropdown-item' key={dropdownItem.id} onClick={() => {
                                props.dropdownSetEnergySource(dropdownItem.id)
                                props.dropdownHideSavings()
                                setSelectedItem(dropdownItem)
                                setIsDropdownOpened(false)
                            }}>
                                {dropdownItem.title}
                            </div>
                        );
                    })}
                </div>
            }
        </div>
    )
}

export default Dropdown;